import React, { memo } from "react";
import { User } from "@common/types/user";
import {
    findIntegrationBySource,
    getUploaderLabel,
    renderUploaderIcon,
} from "../uploaderHelpers";
import styles from "./UploaderDisplay.module.scss";

interface Props {
    uploader: User | null;
    source: string;
}

export const UploaderDisplay: React.FC<Props> = memo(({ uploader, source }) => {
    const integration = findIntegrationBySource(source);

    return (
        <span className={styles.container}>
            {renderUploaderIcon(uploader, integration)}
            {getUploaderLabel(uploader, integration)}
        </span>
    );
});
UploaderDisplay.displayName = "UploaderDisplay";
